// code with partial selection of invoice
// // ─────────────────────────────────────────────────────────────────────────────
// import { useState, useEffect, useRef } from 'react';
// import { Grid, TextField, Button, Typography, Box, Paper, MenuItem, RadioGroup, FormControlLabel, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogContent, Card, CardContent, useMediaQuery, useTheme, Checkbox, } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import axios from 'axios';
// import ClientMaster from "../ClientMaster";
// import { useAuth } from '../../context/AuthContext';
// import CommonServerDataGrid from '../../components/datagridComponent';
// import NoDataComponent from '../../components/NoDataComponent';
// // import dataGridSx from '../theme/datagridTheme';
// import { useGridApiRef } from '@mui/x-data-grid';
// import { Snackbar, Alert } from '@mui/material';
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from 'dayjs';


// const Vouchers = ({ connectionString, drawerOpen }) => {
//     const theme = useTheme();
//     const { user, selectedCompany, loading } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const userCategory = user?.UserCategory || null;
//     const API = connectionString;
//     const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
//     const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

//     const [voucherNo, setVoucherNo] = useState('');
//     const [refNo, setRefNo] = useState('');
//     const [type, setType] = useState('Cr');
//     const [amount, setAmount] = useState('');
//     const [billwise, setBillwise] = useState('no');
//     const [remark, setRemark] = useState('');
//     const [selectedDate, setSelectedDate] = useState(dayjs());
//     const [showClientModal, setShowClientModal] = useState(false);

//     const [companyName, setCompanyName] = useState('');
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [searchResults, setSearchResults] = useState([]);
//     const [selectedParty, setSelectedParty] = useState(null);
//     const partyDropdownRef = useRef();

//     const [rows, setRows] = useState([]);
//     const [idCounter, setIdCounter] = useState(1);
//     const [editingRowIndex, setEditingRowIndex] = useState(null); // <- NEW


//     const [anchorRect, setAnchorRect] = useState(null);
//     const [modalOpen, setModalOpen] = useState(false);

//     const [editingRow, setEditingRow] = useState(null);
//     const [selectedIds, setSelectedIds] = useState([]);
//     const apiRef = useGridApiRef();

//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "success"
//     });

//     const [invoiceData, setInvoiceData] = useState([]);
//     const [loadingInvoices, setLoadingInvoices] = useState(false);
//     const [selectedBills, setSelectedBills] = useState([]);


//     console.log("selectedBills", selectedBills)


//     const fetchInvoices = async () => {
//         if (!selectedParty?.id) return;

//         setLoadingInvoices(true);

//         try {
//             const res = await axios.post(`${API}/api/fetch-invoice-by-client`, {
//                 clientId: selectedParty.id,
//                 clientName: selectedParty.clientname,
//                 companyId,
//                 mode: type === "Cr" ? "sale" : "purc",
//             });

//             const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
//                 ...inv,
//                 id: `${inv.invoiceId}_${inv.BookName}_${inv.BillNumber}`,
//                 originalIndex: index,
//                 BasicAmt: Number(inv.BasicAmt),
//                 RoundOff: Number(inv.RoundOff),
//                 BillAmt: Number(inv.BillAmt),
//                 PaidAmt: Number(inv.PaidAmt),
//                 OSAmt: Number(inv.OSAmt),
//             }));

//             setInvoiceData(invoicesWithIndex);
//         } catch (err) {
//             console.error(err);
//             setInvoiceData([]);
//         } finally {
//             setLoadingInvoices(false);
//         }
//     };
//     const invoiceUsageMap = {};

//     rows.forEach((row, index) => {

//         if (editingRow && row.id === editingRow.id) return;

//         (row.selectedBills || []).forEach(bill => {
//             const id = bill.id; // ✅ composite

//             if (!invoiceUsageMap[id]) {
//                 invoiceUsageMap[id] = {
//                     usedAmount: 0,
//                     rows: []
//                 };
//             }

//             invoiceUsageMap[id].usedAmount += Number(bill.enteredAmount || 0);

//             const displayIndex = rows.length - index;
//             invoiceUsageMap[id].rows.push(displayIndex);
//         });
//     });


//     const currentEditingInvoiceIds =
//         editingRow?.selectedBills?.map(b => b.id) || [];


//     const selectedBillsTotal = selectedBills.reduce(
//         (sum, row) => sum + parseFloat(row.enteredAmount || 0),
//         0
//     );

//     // const alreadySelectedInvoiceIds = rows
//     //     .filter(r => !(editingRow && r.id === editingRow.id))
//     //     .flatMap(r =>
//     //         (r.selectedBills || []).map(b => b.id)   // ✅ composite id
//     //     );

//     useEffect(() => {
//         if (dropdownOpen && partyInputRef.current) {
//             const rect = partyInputRef.current.getBoundingClientRect();
//             setAnchorRect(rect);
//         }
//     }, [dropdownOpen]);


//     useEffect(() => {
//         // 300ms matches MUI drawer transition duration
//         const timer = setTimeout(() => {
//             apiRef.current?.resize?.();
//         }, 300);
//         return () => clearTimeout(timer);
//     }, [drawerOpen]);


//     const partyInputRef = useRef(null);

//     useEffect(() => { fetchReceiptNo('JV'); }, []);

//     const fetchReceiptNo = async (code) => {
//         try {
//             const { data } = await axios.get(`${API}/api/get-receipt-no`, { params: { code } });
//             setVoucherNo(data.receiptNo || '');
//         } catch {
//             setVoucherNo('');
//         }
//     };



//     const isValidForAddToCart =
//         Boolean(selectedParty) &&
//         Boolean(type) &&
//         amount.toString().trim() !== "" &&
//         parseFloat(amount) > 0 &&
//         (
//             billwise === "no" ||
//             selectedBillsTotal === parseFloat(amount)
//         );

//     // const handleAddToCart = () => {
//     //     // if (!selectedParty || !amount || !type) return;


//     //     const ledgerText = [selectedParty.clientname, `Voucher No: ${voucherNo || ''}`, `Ref No: ${refNo || ''}`].join('\n');
//     //     const newEntry = { id: idCounter, ledger: ledgerText, amount, type, partyName: selectedParty.clientname, partyId: selectedParty.id , billwise};

//     //     setRows(prev => {
//     //         const updated = [...prev];
//     //         if (editingRowIndex !== null) {
//     //             updated.splice(editingRowIndex, 0, newEntry); // insert at original index
//     //         } else {
//     //             updated.push(newEntry); // normal add
//     //         }
//     //         return updated;
//     //     });

//     //     // Only increment ID if not editing
//     //     if (editingRowIndex === null) {
//     //         setIdCounter(prev => prev + 1);
//     //     }

//     //     // Reset fields
//     //     setCompanyName('');
//     //     setAmount('');
//     //     setSelectedParty(null);
//     //     setRefNo('');
//     //     setEditingRowIndex(null);
//     // };

//     const handleAddToCart = () => {
//         if (!selectedParty || !amount || !type) return;

//         const newEntry = {
//             id: editingRow ? editingRow.id : idCounter,
//             voucherNo,
//             ledger: selectedParty.clientname,
//             amount,
//             type,
//             partyName: selectedParty.clientname,
//             partyId: selectedParty.id,
//             billwise,
//             selectedBills
//         };

//         setRows(prev => {
//             if (editingRow) {
//                 return prev.map(row =>
//                     row.id === editingRow.id ? newEntry : row
//                 );
//             }
//             return [newEntry, ...prev];
//         });

//         if (!editingRow) {
//             setIdCounter(prev => prev + 1);
//         }

//         // ✅ ALWAYS CLEAR AFTER ADD/UPDATE
//         setCompanyName('');
//         setAmount('');
//         setSelectedParty(null);
//         setEditingRow(null);
//         setEditingRowIndex(null);
//         setBillwise("no");
//         setSelectedBills([]);
//     };

//     const onSelectResult = (party) => {
//         setCompanyName(party.clientname);
//         setSelectedParty({
//             clientname: party.clientname,
//             id: party.id
//         });
//         setDropdownOpen(false);
//     };




//     // ─── fetch search results ─────────────────────────────────────────────
//     useEffect(() => {
//         // if (!dropdownOpen) return;   // ← only fetch when dropdown is open

//         // setLoadingParty(true);
//         const id = setTimeout(async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, {
//                     params: { field: 'FirmName', companyId, search: companyName.trim() || '' }
//                 });
//                 const mappedResults = (res.data.data || []).map(item => ({
//                     clientname: item.FirmName?.trim() || '',
//                     gstno: item.GSTNo || '',
//                     contactPerson: item.ContactPerson?.trim() || '',
//                     mobileNo: item.MobileNo || '',
//                     city: item.City || '',
//                     id: item.id
//                 }));
//                 setSearchResults(mappedResults);
//             } catch {
//                 setSearchResults([]);
//             } finally {
//                 // setLoadingParty(false);
//             }
//         }, 500);
//         return () => clearTimeout(id);
//     }, [companyName, dropdownOpen]);  // ← dropdownOpen triggers fetch on focus

//     console.log("SearchResults", searchResults)


//     function buildReceivablePayload() {
//         // ─── 1) Master fields ─────────────────────────────────────────────
//         const L_NO = 0;                            // sequence no.
//         const PartyId = selectedParty?.id || null;
//         const BankId = null;
//         const BookName = "JV";
//         const ReceiptNumber = voucherNo;
//         const ReceiptDate = selectedDate?.format("YYYY-MM-DD");              // JS Date
//         const RefNo = refNo;
//         const Amount = creditTotal;
//         const BankComm = 0;
//         const TDSAmt = 0;
//         const RoundOffAmt = 0;
//         const PaidAmt = Amount;
//         const VoucherNo = voucherNo;
//         const VoucherTotal = Amount;
//         const Remark = remark;
//         const ClearingAmount = 0;
//         const ClearingDate = null;
//         const CurrencyId = 0;
//         const ExchangeRate = 0;
//         const MultiCurrency = false;
//         const FYear = getCurrentFYear();
//         const CompanyId = companyId;
//         const BranchId = null;
//         const AddUserId = userId;
//         const BillWise = billwise === 'yes' ? 1 : 0;

//         // ─── 2) JV DETAILS for jvdts ─────────────────────────────────────────
//         // one record per DataGrid row
//         const jvDetails = rows.map((r, idx) => ({
//             ReceiptDate: selectedDate?.format("YYYY-MM-DD"),
//             BookName,
//             PartyId: r.partyId,
//             TrType: r.type,
//             Amount: parseFloat(r.amount),
//             ReceiptNumber,
//             CompanyId,
//             Billwise: BillWise
//         }));

//         // ─── 3) BILL-WISE ENTRIES only if billwise is checked ──────────────
//         const billWiseEntries = BillWise === 1
//             ? rows.map((r, index) => ({
//                 SrNo: index + 1,
//                 BillAmt: parseFloat(r.amount),
//                 OSAMT: 0,
//                 ChequeAmt: parseFloat(r.amount),
//                 TDSAmt: 0,
//                 RoundOffAmt: 0,
//                 PaidAmt: parseFloat(r.amount),
//                 InvoiceId: null,
//                 Inv_BillNumber: "",
//                 Inv_BillDate: null,
//                 Inv_BillAmt: parseFloat(r.amount),
//             }))
//             : [];

//         // ─── 4) Final payload ────────────────────────────────────────────────
//         return {
//             // master
//             L_NO, PartyId, BankId, BookName, ReceiptNumber, ReceiptDate,
//             RefNo, Amount, BankComm, TDSAmt, RoundOffAmt, PaidAmt,
//             VoucherNo, VoucherTotal, Remark, ClearingAmount, ClearingDate,
//             CurrencyId, ExchangeRate, MultiCurrency, FYear,
//             CompanyId, BranchId, AddUserId, BillWise,
//             BillWisePaidAmt: Amount,

//             // new sections
//             jvDetails,
//             billWiseEntries
//         };
//     }


//     const handleClear = async () => {
//         // set today's date
//         setSelectedDate(dayjs());

//         // generate new receipt no
//         await fetchReceiptNo('JV');

//         // reset fields
//         setRefNo("");
//         setCompanyName('');
//         setAmount('');
//         setSelectedParty(null);
//         setRemark('');
//         setRows([]);
//         setEditingRow(null);
//         setBillwise("no");
//         setSelectedBills([]);
//     };

//     const handleSubmit = async () => {
//         try {
//             const payload = buildReceivablePayload();
//             console.log("→ Sending payload:", payload);
//             const res = await axios.post(`${API}/api/Vouchers`, payload);
//             if (res.data.success) {
//                 handleClear();
//                 setSnackbar({
//                     open: true,
//                     message: `Saved successfully`,
//                     severity: "success"
//                 })
//             }
//         } catch (err) {
//             console.error(err);
//             setSnackbar({
//                 open: true,
//                 message: "Error saving voucher",
//                 severity: "error"
//             });
//         }
//     };

//     const inputSx = { '& .MuiInputBase-root': { height: 40 } };

//     const columns = [
//         {
//             field: 'srNo',
//             headerName: '#',
//             width: 60,
//             sortable: false,
//             filterable: false,
//             headerAlign: 'center',
//             align: 'center',
//             renderCell: (params) => {
//                 const total = params.api.getRowsCount();
//                 const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
//                 return total - index; // ✅ descending
//             }
//         },
//         {
//             field: 'ledger',
//             headerName: 'Ledger',
//             flex: 3.1,
//             renderCell: (params) => {
//                 const lines = params.value.split('\n');

//                 return (
//                     <Box display="flex" flexDirection="column">
//                         <Typography
//                             variant="subtitle1"
//                             fontWeight={400}
//                             sx={{ cursor: 'pointer', color: 'primary.main' }}
//                             onClick={() => {
//                                 const {
//                                     partyName,
//                                     amount,
//                                     type,
//                                     id,
//                                     voucherNo,
//                                     partyId,
//                                     billwise: rowBillwise,
//                                     selectedBills: rowSelectedBills
//                                 } = params.row;

//                                 setCompanyName(partyName);
//                                 setAmount(amount);
//                                 setType(type);
//                                 setSelectedParty({ clientname: partyName, id: partyId });
//                                 setVoucherNo(voucherNo);

//                                 // ✅ FIXED (use row values, not state)
//                                 setBillwise(rowBillwise || "no");
//                                 setSelectedBills(rowSelectedBills || []);
//                                 setSelectedIds((rowSelectedBills || []).map(b => b.id));
//                                 setEditingRow(params.row);
//                             }}
//                         >
//                             {lines[0] || ''}
//                         </Typography>

//                         {lines.slice(1).map((line, idx) => (
//                             <Typography key={idx} variant="body2" sx={{ whiteSpace: 'pre-line' }}>
//                                 {line}
//                             </Typography>
//                         ))}
//                     </Box>
//                 );
//             }
//         },
//         {
//             field: 'billwise',
//             headerName: 'BillWise',
//             flex: 0.5,
//             headerAlign: 'center',
//             align: 'center',
//             // renderCell: (params) => params.value === 'yes' ? 1 : 0,
//         },
//         {
//             field: 'amount',
//             headerName: 'Amount',
//             flex: 1.4,
//             headerAlign: 'center',
//             align: 'center',
//         },
//         {
//             field: 'type',
//             headerName: 'Type',
//             flex: 0.5,
//             headerAlign: 'center',
//             align: 'center',
//         },
//     ];

//     const creditTotal = rows.filter(r => r.type === 'Cr').reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
//     const debitTotal = rows.filter(r => r.type === 'Dr').reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
//     const canSubmit = creditTotal === debitTotal && creditTotal > 0;

//     return (
//         <>
//             <Box mx="auto" px={2} py={1} pb={0} >
//                 <Typography variant="h5" fontWeight={600} gutterBottom sx={{ textAlign: 'center' }}> Journal Voucher </Typography> </Box>
//             <Box sx={{
//                 px: 2,
//                 boxSizing: 'border-box',
//                 width: '100%',        // ← NOT 100vw
//                 // overflow: 'hidden'
//             }}>
//                 <Grid
//                     container
//                     spacing={2}
//                     sx={{
//                         height: '82vh',
//                     }}
//                 >

//                     {/* Left Form */}
//                     <Grid size={{ xs: 12, lg: 5 }} sx={{
//                         // height: '100%',
//                         display: 'flex'  //required
//                     }}>
//                         <Paper
//                             sx={{
//                                 p: 2,
//                                 flex: 1,          // instead of height:100%
//                                 overflowY: 'auto'
//                             }}
//                         >
//                             {/* Top Header Inputs */}
//                             <Box sx={{ width: '100%', mb: 2 }}>
//                                 <Grid container spacing={2} alignItems="center">
//                                     {/* Date Picker with inline zIndex adjustment */}
//                                     <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
//                                         {/* <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="dd/MM/yyyy" popperPlacement="bottom-start"
//                                             customInput={<TextField label="Date" size="small" fullWidth sx={inputSx} InputLabelProps={{ shrink: true }} />}
//                                         /> */}


//                                         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                             <DatePicker
//                                                 label="Date"
//                                                 format="DD/MM/YYYY"
//                                                 value={selectedDate}
//                                                 onChange={(val) => setSelectedDate(val)}
//                                                 slotProps={{
//                                                     textField: {
//                                                         size: "small",
//                                                         fullWidth: true,
//                                                         sx: inputSx,
//                                                         InputLabelProps: { shrink: true }
//                                                     }
//                                                 }}
//                                             />
//                                         </LocalizationProvider>



//                                     </Grid>

//                                     {/* Voucher No */}
//                                     <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
//                                         <TextField label="Voucher No" size="small" fullWidth disabled sx={inputSx} value={voucherNo} />
//                                     </Grid>

//                                     {/* Ref No */}
//                                     <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
//                                         <TextField label="Ref No" size="small" fullWidth sx={inputSx} value={refNo} onChange={e => setRefNo(e.target.value)} />
//                                     </Grid>
//                                 </Grid>
//                             </Box>

//                             {/* Party Dropdown Search */}
//                             <Grid item size={{ xs: 12 }} sx={{ mb: 2 }} >
//                                 <Box sx={{ position: 'relative', overflow: 'visible' }}>
//                                     <TextField label={<>Party Name <span style={{ color: "red" }}>*</span></>} size="small" fullWidth sx={inputSx} value={companyName} onFocus={() => setDropdownOpen(true)}
//                                         onBlur={(e) => {
//                                             // Delay to allow item selection
//                                             setTimeout(() => setDropdownOpen(false), 100);
//                                         }}
//                                         onChange={(e) => {
//                                             setCompanyName(e.target.value);
//                                             setDropdownOpen(true);
//                                         }}
//                                         inputRef={partyInputRef}
//                                     />

//                                     {dropdownOpen && anchorRect && (
//                                         <Box sx={{
//                                             position: 'fixed',
//                                             left: anchorRect.left,
//                                             top: anchorRect.bottom,
//                                             width: '100%',
//                                             zIndex: 1300, mt: 1, width: isMdDown ? '500px' : "800px", maxHeight: 300, overflowY: 'auto', boxShadow: 4,
//                                         }} >
//                                             {isMdDown ? (
//                                                 // ─── Cards on small/medium ───
//                                                 searchResults.map((r, i) => (
//                                                     <Card key={i} variant="outlined" sx={{ mb: 1, cursor: 'pointer' }} onMouseDown={() => onSelectResult(r)} style={{ backgroundColor: '' }} >
//                                                         <CardContent >
//                                                             <Typography variant="subtitle1" fontWeight="bold">
//                                                                 {r.clientname}
//                                                             </Typography>
//                                                             <Typography variant="body2">GST: {r.gstno}</Typography>
//                                                             <Typography variant="body2">Contact: {r.contactPerson}</Typography>
//                                                             <Typography variant="body2">Mobile: {r.mobileNo}</Typography>
//                                                             <Typography variant="body2">City: {r.city}</Typography>
//                                                         </CardContent>
//                                                     </Card>
//                                                 ))
//                                             ) : (
//                                                 // ─── Table on desktop ───
//                                                 <TableContainer component={Paper}>
//                                                     <Table size="small">
//                                                         <TableHead>
//                                                             <TableRow>
//                                                                 <TableCell>Company</TableCell>
//                                                                 <TableCell>GST No</TableCell>
//                                                                 <TableCell>Contact</TableCell>
//                                                                 <TableCell>Mobile</TableCell>
//                                                                 <TableCell>City</TableCell>
//                                                             </TableRow>
//                                                         </TableHead>
//                                                         <TableBody>
//                                                             {searchResults.length > 0 ? (
//                                                                 searchResults.map((r, i) => (
//                                                                     <TableRow key={i} hover sx={{ cursor: 'pointer' }} onMouseDown={() => onSelectResult(r)} >
//                                                                         <TableCell>{r.clientname}</TableCell>
//                                                                         <TableCell>{r.gstno}</TableCell>
//                                                                         <TableCell>{r.contactPerson}</TableCell>
//                                                                         <TableCell>{r.mobileNo}</TableCell>
//                                                                         <TableCell>{r.city}</TableCell>
//                                                                     </TableRow>
//                                                                 ))
//                                                             ) : (
//                                                                 <TableRow>
//                                                                     <TableCell colSpan={5} align="center"> No Data Available </TableCell>
//                                                                 </TableRow>
//                                                             )}
//                                                             <TableRow hover sx={{ cursor: 'pointer' }} onMouseDown={() => setShowClientModal(true)} >
//                                                                 <TableCell colSpan={5} align="center" sx={{ color: 'primary.main' }}>
//                                                                     ➕ Add New Client
//                                                                 </TableCell>
//                                                             </TableRow>
//                                                         </TableBody>
//                                                     </Table>
//                                                 </TableContainer>
//                                             )}
//                                         </Box>
//                                     )}
//                                 </Box>
//                             </Grid>

//                             <Grid container spacing={2}>

//                                 <Grid item size={{ xs: 4 }}>

//                                     <Grid container spacing={2} direction="column">
//                                         <Grid item >
//                                             <TextField select label={<>Type <span style={{ color: "red" }}>*</span></>} size="small" fullWidth value={type} onChange={e => setType(e.target.value)}>
//                                                 <MenuItem value="Cr">Cr</MenuItem>
//                                                 <MenuItem value="Dr">Dr</MenuItem>
//                                             </TextField>
//                                         </Grid>

//                                         <Grid item >
//                                             <TextField label={<>Amount <span style={{ color: "red" }}>*</span></>} size="small" fullWidth value={amount}
//                                                 onChange={e => {
//                                                     if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
//                                                         setAmount(e.target.value);
//                                                     }
//                                                 }}
//                                             />
//                                         </Grid>

//                                     </Grid>
//                                 </Grid>

//                                 {/* Remark */}
//                                 <Grid item size={{ xs: 8 }}>
//                                     <TextField label="Remark" value={remark} onChange={e => setRemark(e.target.value)} fullWidth multiline size="small" sx={{ mb: 2 }} rows={3.5} />
//                                 </Grid>
//                             </Grid>

//                             {/* Billwise Checkbox */}
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <Box display="flex" alignItems="center" my={1} pl={2}>
//                                     <FormControlLabel
//                                         control={
//                                             <Checkbox
//                                                 checked={billwise === 'yes'}
//                                                 onChange={(e) =>
//                                                     setBillwise(e.target.checked ? 'yes' : 'no')
//                                                 }
//                                                 color="primary"
//                                             />
//                                         }
//                                         label="Billwise?"
//                                     />
//                                 </Box>
//                                 {(billwise === "yes") && <Box>
//                                     <Button
//                                         variant="outlined"
//                                         onClick={() => {
//                                             fetchInvoices();
//                                             // ✅ sync selection
//                                             setSelectedIds(selectedBills.map(b => b.id));

//                                             setModalOpen(true);
//                                         }}
//                                         disabled={!selectedParty || !type || Number(amount) <= 0}

//                                     >
//                                         Show Bills
//                                     </Button>
//                                 </Box>}
//                             </Box>


//                             {/* Add Button */}
//                             <Box display="flex" justifyContent="center" mt={2}>
//                                 <Button variant="contained" size="large" sx={{ width: 200 }} onClick={handleAddToCart} disabled={!isValidForAddToCart}>
//                                     {editingRow ? 'Update Cart' : 'Add to Cart'}
//                                 </Button>
//                             </Box>

//                             {billwise === "yes" && selectedBills.length > 0 && (
//                                 <Box mt={3}>
//                                     <Typography fontWeight="bold">Selected Bills</Typography>

//                                     <DataGrid
//                                         rows={selectedBills}
//                                         columns={[
//                                             { field: "BillNumber", headerName: "Invoice No", flex: 1.2 },
//                                             { field: "BookName", headerName: "Book Name", flex: 0.8 },
//                                             { field: "BillDate", headerName: "Bill Date", flex: 1 },
//                                             { field: "OSAmt", headerName: "O/S Amount", flex: 1 },
//                                             {
//                                                 field: "Remaining",
//                                                 headerName: "Remaining",
//                                                 flex: 1,
//                                                 renderCell: (params) => {
//                                                     const id = params.row.id;

//                                                     const usedFromRows = invoiceUsageMap[id]?.usedAmount || 0;

//                                                     const usedFromCurrent = selectedBills
//                                                         .filter(b => b.id === id && b.id !== params.row.id)
//                                                         .reduce((sum, b) => sum + Number(b.enteredAmount || 0), 0);

//                                                     const totalUsed = usedFromRows + usedFromCurrent;

//                                                     const remaining = Number(params.row.OSAmt) - totalUsed;

//                                                     return (
//                                                         <span style={{
//                                                             color: remaining === 0 ? "red" : "green",
//                                                             fontWeight: 500
//                                                         }}>
//                                                             {remaining}
//                                                         </span>
//                                                     );
//                                                 }
//                                             },

//                                             {
//                                                 field: "enteredAmount",
//                                                 headerName: "Amount",
//                                                 flex: 1,
//                                                 renderCell: (params) => (
//                                                     <TextField
//                                                         size="small"
//                                                         value={params.row.enteredAmount}
//                                                         inputProps={{
//                                                             inputMode: "decimal",
//                                                             pattern: "^[0-9]*\\.?[0-9]*$",
//                                                             min: 0
//                                                         }}
//                                                         onChange={(e) => {
//                                                             const raw = e.target.value;

//                                                             // ❌ block invalid input (only numbers + decimal, no negative)
//                                                             if (!/^\d*\.?\d{0,2}$/.test(raw)) return;

//                                                             const val = Number(raw || 0);
//                                                             const id = params.row.id;

//                                                             const usedFromRows = invoiceUsageMap[id]?.usedAmount || 0;

//                                                             const usedFromCurrent = selectedBills
//                                                                 .filter(b => b.id === id && b.id !== params.row.id)
//                                                                 .reduce((sum, b) => sum + Number(b.enteredAmount || 0), 0);

//                                                             const totalUsed = usedFromRows + usedFromCurrent;

//                                                             const max = Number(params.row.OSAmt) - totalUsed;

//                                                             // ❌ prevent over allocation
//                                                             if (val > max) {
//                                                                 setSnackbar({
//                                                                     open: true,
//                                                                     message: `Max allowed: ${max}`,
//                                                                     severity: "warning"
//                                                                 });
//                                                                 return;
//                                                             }

//                                                             // ❌ prevent negative (extra safety)
//                                                             if (val < 0) return;

//                                                             setSelectedBills(prev =>
//                                                                 prev.map(row =>
//                                                                     row.id === id
//                                                                         ? { ...row, enteredAmount: raw } // keep string for smooth typing
//                                                                         : row
//                                                                 )
//                                                             );
//                                                         }}
//                                                     />
//                                                 )
//                                             }
//                                         ]}
//                                         getRowId={(row) => row.id}
//                                         hideFooter
//                                         sx={{ mt: 1 }}
//                                     />
//                                 </Box>
//                             )}
//                         </Paper>
//                     </Grid>

//                     {/* Right Grid - Data Table */}
//                     <Grid

//                         size={{ xs: 12, lg: 7 }}
//                         sx={{
//                             height: '100%',
//                             display: 'flex', //REQUIRED
//                             minWidth: 0,
//                         }}
//                     >
//                         <Paper
//                             sx={{
//                                 flex: 1,                  //  THIS replaces height:100%
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 minHeight: 0,          //  CRITICAL for DataGrid
//                                 minWidth: 0,     // ← add this
//                                 overflow: 'hidden'  // ← add this
//                             }}
//                         >
//                             {/* Scrollable DataGrid */}
//                             <Box
//                                 sx={{
//                                     flex: 1,
//                                     minHeight: 0,             //  CRITICAL
//                                     overflow: 'hidden'
//                                 }}
//                             >
//                                 <DataGrid
//                                     apiRef={apiRef}
//                                     rows={rows}
//                                     columns={columns}
//                                     // ✅ remove hideFooter
//                                     initialState={{
//                                         pagination: { paginationModel: { pageSize: 10 } },
//                                     }}
//                                     pageSizeOptions={[10, 20, 30]}
//                                     getRowHeight={() => 'auto'}
//                                     disableRowSelectionOnClick
//                                     slots={{
//                                         noRowsOverlay: () => (
//                                             <NoDataComponent />
//                                         ),
//                                     }}
//                                     sx={{
//                                         height: "100%",
//                                         border: '1px solid #cbd5e1',
//                                         borderRadius: 1,
//                                         '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
//                                         '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

//                                         // Background styling
//                                         '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                                         '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

//                                         // Row styling
//                                         '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                         '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
//                                         '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

//                                         // Selected row styling (with !important to override default MUI)
//                                         '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },
//                                         "& .MuiDataGrid-footerContainer": {
//                                             minHeight: "35px",
//                                             maxHeight: "35px",
//                                         },
//                                     }}

//                                 />
//                                 {/* <CommonServerDataGrid
//     data={rows.slice().reverse()}
//     columns={columns}
//     getRowId={(row) => row.id}
//     role={userCategory}          // or any role logic you use
//     // selectionModel={selectionModel}
//     // onSelectionModelChange={setSelectionModel}
//     hideFooter                   // if your reusable grid supports it
//     getRowHeight={() => "auto"}  // forwarded to MUI DataGrid
// /> */}

//                             </Box>

//                             {/* Footer */}
//                             <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
//                                 <Box>
//                                     <Typography variant="subtitle1">Total Credit: ₹{creditTotal.toFixed(2)}</Typography>
//                                     <Typography variant="subtitle1">Total Debit: ₹{debitTotal.toFixed(2)}</Typography>
//                                 </Box>
//                                 <Button variant="contained" color="success" disabled={!canSubmit} onClick={handleSubmit} sx={{ minWidth: 140 }} >
//                                     Submit Voucher
//                                 </Button>
//                             </Box>
//                         </Paper>
//                     </Grid>
//                 </Grid>


//                 <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                     <Alert
//                         severity={snackbar.severity}
//                         variant="filled"
//                         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//                     >
//                         {snackbar.message}
//                     </Alert>
//                 </Snackbar>

//                 <Dialog
//                     open={modalOpen}
//                     onClose={() => setModalOpen(false)}
//                     maxWidth="lg"
//                     fullWidth
//                 >
//                     <Box
//                         sx={{
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             padding: "10px 18px 0px 18px"
//                         }}
//                     >
//                         <Typography fontWeight="bold">
//                             Pending Invoices
//                         </Typography>

//                         <Typography sx={{ fontWeight: 500 }}>
//                             Amount: {parseFloat(amount || 0).toFixed(2)}
//                         </Typography>
//                     </Box>


//                     <DialogContent
//                         sx={{
//                             height: "80vh",
//                             display: "flex",
//                             flexDirection: "column",
//                             p: 2
//                         }}
//                     >

//                         <DataGrid
//                             rows={invoiceData}
//                             columns={[
//                                 {
//                                     field: "BillNumber",
//                                     headerName: "Bill No",
//                                     flex: 1,
//                                     renderCell: (params) => {
//                                         const used = invoiceUsageMap[params.row.id]?.usedAmount || 0;
//                                         const remaining = params.row.OSAmt - used;

//                                         const isFullyUsed = remaining === 0;
//                                         const isPartial = used > 0 && remaining > 0;

//                                         return (
//                                             <Box display="flex" alignItems="center" gap={1}>
//                                                 <span>{params.value}</span>

//                                                 {isFullyUsed && (
//                                                     <span
//                                                         style={{
//                                                             backgroundColor: "#d32f2f",
//                                                             color: "#fff",
//                                                             padding: "2px 8px",
//                                                             borderRadius: "12px",
//                                                             fontSize: "11px",
//                                                             fontWeight: 500,
//                                                             lineHeight: 1.5
//                                                         }}
//                                                     >
//                                                         Full
//                                                     </span>
//                                                 )}

//                                                 {isPartial && (
//                                                     <span
//                                                         style={{
//                                                             backgroundColor: "#f57c00",
//                                                             color: "#fff",
//                                                             padding: "2px 8px",
//                                                             borderRadius: "12px",
//                                                             fontSize: "11px",
//                                                             fontWeight: 500,
//                                                             lineHeight: 1.5
//                                                         }}
//                                                     >
//                                                         Partial
//                                                     </span>
//                                                 )}
//                                             </Box>
//                                         );
//                                     }
//                                 },
//                                 { field: "BookName", headerName: "Book Name ", flex: 1 },
//                                 { field: "BillDate", headerName: "Bill Date", flex: 1 },
//                                 { field: "OSAmt", headerName: "O/S Amount", flex: 1 },
//                                 {
//                                     field: "UsedIn",
//                                     headerName: "Used In",
//                                     flex: 1,
//                                     renderCell: (params) => {
//                                         const id = params.row.id;

//                                         const rowsUsed = invoiceUsageMap[id]?.rows || [];

//                                         return rowsUsed.length > 0
//                                             ? `row-${rowsUsed.join(", ")}`
//                                             : "-";
//                                     }
//                                 },
//                                 {
//                                     field: "Remaining",
//                                     headerName: "Remaining",
//                                     flex: 1,
//                                     renderCell: (params) => {
//                                         const id = params.row.id;

//                                         const used = invoiceUsageMap[id]?.usedAmount || 0;
//                                         const remaining = Number(params.row.OSAmt) - used;

//                                         return (
//                                             <span style={{
//                                                 color: remaining === 0 ? "red" : "green",
//                                                 fontWeight: 500
//                                             }}>
//                                                 {remaining}
//                                             </span>
//                                         );
//                                     }
//                                 },
//                                 { field: "DueDate", headerName: "Due Date", flex: 1 },

//                             ]}

//                             slots={{
//                                 noRowsOverlay: () => (
//                                     <NoDataComponent />
//                                 ),
//                             }}

//                             checkboxSelection
//                             disableRowSelectionOnClick
//                             rowSelectionModel={selectedIds}
//                             onRowSelectionModelChange={(ids) => setSelectedIds(ids)}
//                             isRowSelectable={(params) => {
//                                 const id = params.row.id;

//                                 const used = invoiceUsageMap[id]?.usedAmount || 0;
//                                 const remaining = Number(params.row.OSAmt) - used;

//                                 const isCurrent = currentEditingInvoiceIds.includes(id);

//                                 if (isCurrent) return true;

//                                 return remaining > 0;
//                             }}
//                             getRowClassName={(params) => {
//                                 const id = params.row.id;

//                                 const used = invoiceUsageMap[id]?.usedAmount || 0;
//                                 const remaining = Number(params.row.OSAmt) - used;

//                                 const isCurrent = currentEditingInvoiceIds.includes(id);

//                                 if (isCurrent) return "current-row";
//                                 if (remaining === 0) return "fully-used";
//                                 if (used > 0) return "partial-used";

//                                 return "";
//                             }}

//                             sx={{
//                                 height: "100%",

//                                 "& .fully-used": {
//                                     backgroundColor: "#ffecec",
//                                     color: "#d32f2f",
//                                     pointerEvents: "none"
//                                 },

//                                 "& .partial-used": {
//                                     backgroundColor: "#fff8e1",
//                                     color: "#f57c00"
//                                 },

//                                 "& .current-row": {
//                                     backgroundColor: "#e3f2fd"
//                                 }
//                             }}
//                         />

//                         <Box
//                             sx={{
//                                 mt: 1,
//                                 pt: 1,
//                                 borderTop: "1px solid #d0d4d9",
//                                 display: "flex",
//                                 justifyContent: "space-between"
//                             }}
//                         >
//                             {/* <Typography sx={{ fontWeight: "bold", color: "#1a3c6c" }}>
//                                             Selected O/S Total: {selectedPendingTotal.toFixed(2)}
//                                         </Typography> */}
//                         </Box>


//                         <Box sx={{ textAlign: "right", mt: 2 }}>
//                             <Button
//                                 variant="contained"
//                                 sx={{ mr: 2 }}
//                                 disabled={selectedIds.length === 0}
//                                 onClick={() => {
//                                     const selectedRows = invoiceData.filter(row =>
//                                         selectedIds.includes(row.id)
//                                     );

//                                     // const alreadySelectedInvoiceIds = rows
//                                     //     .filter(r => !(editingRow && r.id === editingRow.id))
//                                     //     .flatMap(r =>
//                                     //         (r.selectedBills || []).map(b => b.id)   // ✅ composite id
//                                     //     );

//                                     // ❌ remove duplicates
//                                     const filtered = selectedRows.filter(row => {
//                                         const id = row.id;

//                                         const used = invoiceUsageMap[id]?.usedAmount || 0;
//                                         const remaining = row.OSAmt - used;

//                                         // ❌ block only if fully used
//                                         return remaining > 0;
//                                     });

//                                     const blockedRows = selectedRows.filter(row => {
//                                         const id = row.id;
//                                         const used = invoiceUsageMap[id]?.usedAmount || 0;
//                                         const remaining = row.OSAmt - used;

//                                         return remaining === 0;
//                                     });

//                                     if (blockedRows.length > 0) {
//                                         setSnackbar({
//                                             open: true,
//                                             message: "Some invoices are fully used and cannot be selected",
//                                             severity: "warning"
//                                         });
//                                     }

//                                     const formatted = filtered.map(row => {
//                                         const used = invoiceUsageMap[row.id]?.usedAmount || 0;
//                                         const remaining = Number(row.OSAmt) - used;

//                                         return {
//                                             ...row,
//                                             id: row.id, // ✅ already composite
//                                             enteredAmount: remaining
//                                         };
//                                     });

//                                     setSelectedBills(formatted);

//                                     // ✅ sync selection
//                                     setSelectedIds(formatted.map(b => b.id));
//                                     setModalOpen(false);
//                                 }}
//                             >
//                                 Save
//                             </Button>

//                             <Button
//                                 onClick={() => setModalOpen(false)}
//                                 variant="outlined"
//                             >
//                                 Cancel
//                             </Button>
//                         </Box>


//                     </DialogContent>
//                 </Dialog>

//             </Box>
//         </>
//     );
// };

// export default Vouchers;






// ─────────────────────────────────────────────────────────────────────────────
// src/Pages/Payable/Vouchers.jsx  —  DESIGN LAYER
//
// ┌─────────────────────────────────────────────────────────────────────────┐
// │  Module  : Payable                                                     │
// │  Role    : Accounts payable — payable ledger and vouchers                                                       │
// ├─────────────────────────────────────────────────────────────────────────┤
// │    ✅ JSX render tree                                                    │
// │    ✅ useTheme() for dark/light colour tokens                            │
// │    ✅ Layout, spacing, responsive breakpoints                            │
// │    ❌ NO useState/useEffect/axios → see Vouchers.logic.js                 │
// └─────────────────────────────────────────────────────────────────────────┘
//
// Dark-mode:  const theme = useTheme();  const isDark = theme.palette.mode === "dark";
// Logic split: Vouchers.logic.js  ←→  Vouchers.jsx
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useEffect, useRef } from 'react';
import { Grid, TextField, Button, Typography, Box, Paper, MenuItem, RadioGroup, FormControlLabel, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogContent, Card, CardContent, useMediaQuery, useTheme, Checkbox, DialogTitle, } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import ClientMaster from "../ClientMaster";
import { useAuth } from '../../context/AuthContext';
import CommonServerDataGrid from '../../components/datagridComponent';
import NoDataComponent from '../../components/NoDataComponent';
// import dataGridSx from '../theme/datagridTheme';
import { useGridApiRef } from '@mui/x-data-grid';
import { Snackbar, Alert } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { Chip, Tooltip } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import { getCurrentFYear, getFinancialYearBounds } from '../../utils/financialYear';


const SelectedBillCard = ({ row, selectedIds, setSelectedIds, setSelectedBills, invoiceUsageMap, setSnackbar }) => {
    return (
        <Box
            sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 1.5,
                mb: 1,
                bgcolor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
            }}
        >
            {/* Row 1: Checkbox + Bill No + Date */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 0.8 }}>
                <Checkbox
                    size="small"
                    checked={selectedIds.includes(row.id)}
                    onChange={(e) => {
                        if (!e.target.checked) {
                            setSelectedBills(prev => prev.filter(b => b.id !== row.id));
                            setSelectedIds(prev => prev.filter(id => id !== row.id));
                        }
                    }}
                    sx={{ p: 0.5, mr: 0.5 }}
                />
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontWeight: 700, fontSize: "0.88rem" }}>
                            {row.BillNumber}
                        </Typography>
                        <Typography sx={{ fontSize: "0.75rem", color: "#888" }}>
                            {row.BillDate ? new Date(row.BillDate).toLocaleDateString("en-GB") : ""}
                        </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.75rem", color: "#666" }}>
                        {row.BookName}
                    </Typography>
                </Box>
            </Box>

            {/* Row 2: O/S Amount */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, px: 0.5 }}>
                <Typography sx={{ fontSize: "0.75rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                    O/S Amount
                </Typography>
                <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#1976d2" }}>
                    {Number(row.OSAmt || 0).toFixed(2)}
                </Typography>
            </Box>

            {/* Row 3: Amount Input */}
            <Box>
                <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3, fontWeight: 500 }}>
                    Amount
                </Typography>
                <TextField
                    size="small"
                    fullWidth
                    value={row.enteredAmount}
                    inputProps={{ inputMode: "decimal", pattern: "^[0-9]*\\.?[0-9]*$" }}
                    onChange={(e) => {
                        const raw = e.target.value;
                        if (!/^\d*\.?\d{0,2}$/.test(raw)) return;

                        const val = Number(raw || 0);
                        const id = row.id;

                        const usedFromRows = invoiceUsageMap[id]?.usedAmount || 0;
                        const usedFromCurrent = 0; // single entry per bill in mobile
                        const totalUsed = usedFromRows + usedFromCurrent;
                        const max = Number(row.OSAmt) - totalUsed;

                        if (val > max) {
                            setSnackbar({ open: true, message: `Max allowed: ${max}`, severity: "warning" });
                            return;
                        }
                        if (val < 0) return;

                        setSelectedBills(prev => {
                            const updated = prev.map(b =>
                                b.id === id ? { ...b, enteredAmount: raw } : b
                            );
                            setSelectedIds(updated.map(r => r.id));
                            return updated;
                        });
                    }}
                    sx={{ "& .MuiInputBase-root": { borderRadius: "4px" } }}
                />
            </Box>
        </Box>
    );
};


const PendingInvoiceCard = ({ row, selectedIds, setSelectedIds, selectedBills, setSelectedBills, invoiceUsageMap, currentEditingInvoiceIds }) => {
    const id = row.id;
    const isUsed = !!invoiceUsageMap[id];
    const isCurrent = currentEditingInvoiceIds.includes(id);
    const isSelectable = isCurrent || !isUsed;
    const isChecked = selectedIds.includes(id);

    return (
        <Box
            sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 1.5,
                mb: 1.2,
                bgcolor: isUsed && !isCurrent ? "#ffecec" : isCurrent ? "#e3f2fd" : "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                opacity: isSelectable ? 1 : 0.7
            }}
        >
            {/* Row 1: Checkbox + Bill No + Date */}
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 0.8 }}>
                <Checkbox
                    size="small"
                    checked={isChecked}
                    disabled={!isSelectable}
                    onChange={(e) => {
                        if (!isSelectable) return;

                        if (e.target.checked) {
                            const used = invoiceUsageMap[row.id]?.usedAmount || 0;
                            const existing = selectedBills.find(b => b.id === row.id);
                            const newBill = { ...row, enteredAmount: existing?.enteredAmount ?? "" };

                            setSelectedIds(prev => [...prev, id]);
                            setSelectedBills(prev => [...prev, newBill]);
                        } else {
                            setSelectedIds(prev => prev.filter(i => i !== id));
                            setSelectedBills(prev => prev.filter(b => b.id !== id));
                        }
                    }}
                    sx={{ p: 0.5, mr: 0.5 }}
                />
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 0.5 }}>
                        <Typography sx={{ fontWeight: 700, fontSize: "0.88rem" }}>
                            {row.BillNumber}
                        </Typography>
                        {isUsed && !isCurrent && (
                            <Box sx={{ bgcolor: "#d32f2f", color: "#fff", px: 1, py: 0.2, borderRadius: 5, fontSize: "11px", fontWeight: 500 }}>
                                Used
                            </Box>
                        )}
                        <Typography sx={{ fontSize: "0.75rem", color: "#888" }}>
                            {row.BillDate ? new Date(row.BillDate).toLocaleDateString("en-GB") : ""}
                        </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.75rem", color: "#666", mt: 0.2 }}>
                        {row.BookName}
                    </Typography>
                </Box>
            </Box>

            {/* Row 2: O/S Amount + Due Date */}
            <Box sx={{ display: "flex", justifyContent: "space-between", pl: 4.5 }}>
                <Box>
                    <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                        O/S Amount
                    </Typography>
                    <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, color: "#1976d2" }}>
                        {Number(row.OSAmt || 0).toFixed(2)}
                    </Typography>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                    <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                        Due Date
                    </Typography>
                    <Typography sx={{ fontSize: "0.82rem" }}>
                        {row.DueDate ? new Date(row.DueDate).toLocaleDateString("en-GB") : "-"}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};


const CartRowCard = ({ row, index, total, onEdit }) => (
    <Box
        sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 1.5,
            mb: 1.2,
            bgcolor: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
        }}
    >
        {/* Row 1: Sr No + Party Name + Type badge */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.8 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontSize: "0.72rem", color: "#999", fontWeight: 600, minWidth: 20 }}>
                    #{total - index}
                </Typography>
                <Typography
                    sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#1976d2", cursor: "pointer" }}
                    onClick={onEdit}
                >
                    {row.partyName}
                </Typography>
            </Box>
            <Box sx={{
                px: 1, py: 0.2, borderRadius: 1, fontSize: "0.75rem", fontWeight: 700,
                bgcolor: row.type === "Cr" ? "#e8f5e9" : "#fff3e0",
                color: row.type === "Cr" ? "#2e7d32" : "#e65100"
            }}>
                {row.type}
            </Box>
        </Box>

        {/* Row 2: Amount + BillWise */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box>
                <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                    Amount
                </Typography>
                <Typography sx={{ fontSize: "0.88rem", fontWeight: 600 }}>
                    ₹{Number(row.amount || 0).toFixed(2)}
                </Typography>
            </Box>
            <Box sx={{ textAlign: "right" }}>
                <Typography sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600, textTransform: "uppercase" }}>
                    BillWise
                </Typography>
                <Typography sx={{ fontSize: "0.82rem" }}>
                    {row.billwise
                        ? row.billwise.toLowerCase().replace(/\b\w/g, c => c.toUpperCase())
                        : ""}
                </Typography>
            </Box>
        </Box>
    </Box>
);


const Vouchers = ({ connectionString, drawerOpen }) => {
    const theme = useTheme();
    const { user, selectedCompany, loading } = useAuth();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const userCategory = user?.UserCategory || null;
    const API = connectionString;
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    const [voucherNo, setVoucherNo] = useState('');
    const [refNo, setRefNo] = useState('');
    const [type, setType] = useState('Cr');
    const [amount, setAmount] = useState('');
    const [billwise, setBillwise] = useState('no');
    const [remark, setRemark] = useState('');
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const { startDate: fyStartDate, endDate: fyEndDate } = getFinancialYearBounds();
    const [showClientModal, setShowClientModal] = useState(false);

    const [companyName, setCompanyName] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [selectedParty, setSelectedParty] = useState(null);
    const partyDropdownRef = useRef();

    const [rows, setRows] = useState([]);
    const [idCounter, setIdCounter] = useState(1);
    const [editingRowIndex, setEditingRowIndex] = useState(null); // <- NEW

    const { id } = useParams();
    const isEditMode = Boolean(id);


    const [billsSnapshot, setBillsSnapshot] = useState([]);
    const [idsSnapshot, setIdsSnapshot] = useState([]);


    const [anchorRect, setAnchorRect] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const [editingRow, setEditingRow] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const apiRef = useGridApiRef();

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const [invoiceData, setInvoiceData] = useState([]);
    const [loadingInvoices, setLoadingInvoices] = useState(false);
    const [selectedBills, setSelectedBills] = useState([]);

    const [removeBillsWarningOpen, setRemoveBillsWarningOpen] = useState(false);


    const [confirmWithoutBillsOpen, setConfirmWithoutBillsOpen] = useState(false);


    console.log("selectedBills", selectedBills)


    const fetchInvoices = async () => {
        if (!selectedParty?.id) return [];

        setLoadingInvoices(true);

        try {
            const res = await axios.post(`${API}/api/fetch-invoice-by-client`, {
                clientId: selectedParty.id,
                clientName: selectedParty.clientname,
                companyId,
                mode: type === "Cr" ? "sale" : "purc",
            });

            const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
                ...inv,
                id: `${inv.invoiceId}_${inv.BookName}_${inv.BillNumber}`,
                originalIndex: index,
                BasicAmt: Number(inv.BasicAmt),
                RoundOff: Number(inv.RoundOff),
                BillAmt: Number(inv.BillAmt),
                PaidAmt: Number(inv.PaidAmt),
                OSAmt: Number(inv.OSAmt),
            }));

            setInvoiceData(invoicesWithIndex);

            return invoicesWithIndex; // ✅ IMPORTANT FIX
        } catch (err) {
            console.error(err);
            setInvoiceData([]);
            return []; // ✅ safe return
        } finally {
            setLoadingInvoices(false);
        }
    };

    useEffect(() => {
        if (!id || !companyId) return;

        const fetchVoucher = async () => {
            try {

                const res = await axios.get(`${API}/api/get-voucher-by-id`, {
                    params: { receiptId: id, companyId }
                });

                const { master, details, billwise } = res.data;

                const billsByParty = {};

                (billwise || []).forEach(b => {
                    if (!billsByParty[b.PartyId]) {
                        billsByParty[b.PartyId] = [];
                    }

                    billsByParty[b.PartyId].push({
                        id: `${b.InvoiceId || b.Inv_BillNumber}_${b.BookName}_${b.BillNumber}`,
                        invoiceId: b.InvoiceId,
                        PurcInvoiceId: b.PurcInvoiceId || null,
                        SaleInvoiceId: b.SaleInvoiceId || null,
                        BillNumber: b.BillNumber,
                        BillDate: b.BillDate,
                        BillAmt: Number(b.BillAmt),
                        BookName: b.BookName,
                        enteredAmount: Number(b.PaidAmt || 0),
                        OSAmt: Number(b.OSAMT),
                    });
                });

                // ✅ MASTER
                setVoucherNo(master.ReceiptNumber || "");
                setRefNo(master.RefNo || "");
                setRemark(master.Remark || "");
                setSelectedDate(master.ReceiptDate ? dayjs(master.ReceiptDate) : dayjs());

                // ✅ PARTY (WITH NAME)
                setSelectedParty({
                    id: master.PartyId,
                    clientname: master.partyName || ""
                });
                setCompanyName(master.partyName || "");

                // ✅ DETAILS → GRID (FIXED)
                // const mappedRows = details.map((row, index) => ({
                //     id: index + 1,
                //     ledger: row.partyName,
                //     partyName: row.partyName,
                //     partyId: row.PartyId,
                //     amount: row.Debit || row.Credit || 0,
                //     type: row.Debit ? "Dr" : "Cr",
                //     billwise: row.Billwise === 1 ? "yes" : "no",

                //     selectedBills: billsByParty[row.PartyId] || [] // ✅ correct
                // }));

                const mappedRows = details.map((row, index) => ({
                    id: index + 1,
                    ledger: row.partyName,
                    partyName: row.partyName,
                    partyId: row.PartyId,

                    type: row.TrType, // ✅ ALWAYS use backend

                    amount:
                        row.TrType === "Dr"
                            ? Number(row.Debit || 0)
                            : Number(row.Credit || 0),

                    billwise: row.Billwise === 1 ? "yes" : "no",

                    selectedBills: billsByParty[row.PartyId] || []
                }));

                setRows(mappedRows);

                // ✅ VERY IMPORTANT
                setIdCounter(mappedRows.length + 1);

            } catch (err) {
                console.error("Edit fetch error:", err);
            }
        };

        fetchVoucher();
    }, [id, companyId]);

    const autoSelectBills = (invoices) => {
        let remainingAmount = Number(amount);

        // ✅ sort oldest first
        const sorted = [...invoices].sort(
            (a, b) => new Date(a.BillDate) - new Date(b.BillDate)
        );

        const selected = [];

        for (let inv of sorted) {
            const id = inv.id;

            // ❌ skip already used invoices
            if (invoiceUsageMap[id]) continue;

            if (remainingAmount <= 0) break;

            const os = Number(inv.OSAmt);

            // ❌ skip if O/S is 0
            if (os <= 0) continue;

            // ✅ take full or partial (depending on remaining)
            const takeAmount = Math.min(os, remainingAmount);

            selected.push({
                ...inv,
                enteredAmount: takeAmount
            });

            remainingAmount -= takeAmount;
        }

        // ⚠️ if not enough bills
        if (remainingAmount > 0) {
            setSnackbar({
                open: true,
                message: "Not enough pending bills to match amount",
                severity: "warning"
            });
        }

        // ✅ update state
        setSelectedBills(selected);
        setSelectedIds(selected.map(b => b.id));
    };

    const handleAutoSelect = async () => {
        if (!selectedParty || !type || Number(amount) <= 0) return;

        const data = await fetchInvoices(); // ✅ fetch here

        if (!data || data.length === 0) {
            setSnackbar({
                open: true,
                message: "No invoices found",
                severity: "warning"
            });
            return;
        }

        autoSelectBills(data); // ✅ select

    };
    const invoiceUsageMap = {};

    rows.forEach((row, index) => {

        if (editingRow && row.id === editingRow.id) return;

        (row.selectedBills || []).forEach(bill => {
            const id = bill.id; // ✅ composite

            if (!invoiceUsageMap[id]) {
                invoiceUsageMap[id] = {
                    usedAmount: 0,
                    rows: []
                };
            }

            invoiceUsageMap[id].usedAmount += Number(bill.enteredAmount || 0);

            const displayIndex = rows.length - index;
            invoiceUsageMap[id].rows.push(displayIndex);
        });
    });


    const currentEditingInvoiceIds =
        editingRow?.selectedBills?.map(b => b.id) || [];


    const selectedBillsTotal = selectedBills.reduce(
        (sum, row) => sum + parseFloat(row.enteredAmount || 0),
        0
    );

    // const alreadySelectedInvoiceIds = rows
    //     .filter(r => !(editingRow && r.id === editingRow.id))
    //     .flatMap(r =>
    //         (r.selectedBills || []).map(b => b.id)   // ✅ composite id
    //     );

    useEffect(() => {
        if (dropdownOpen && partyInputRef.current) {
            const rect = partyInputRef.current.getBoundingClientRect();
            setAnchorRect(rect);
        }
    }, [dropdownOpen]);



    useEffect(() => {
        // 300ms matches MUI drawer transition duration
        const timer = setTimeout(() => {
            apiRef.current?.resize?.();
        }, 300);
        return () => clearTimeout(timer);
    }, [drawerOpen]);


    const partyInputRef = useRef(null);

    useEffect(() => {
        if (!isEditMode) {
            fetchReceiptNo('JV');
        }
    }, [isEditMode]);

    const fetchReceiptNo = async (code) => {
        try {
            const { data } = await axios.get(`${API}/api/get-receipt-no`, { params: { code, companyId } });
            setVoucherNo(data.receiptNo || '');
        } catch {
            setVoucherNo('');
        }
    };



    const hasValidBillAmounts =
        selectedBills.some(
            bill => parseFloat(bill.enteredAmount || 0) > 0
        );

    const isValidForAddToCart =
        Boolean(selectedParty) &&
        Boolean(type) &&
        amount.toString().trim() !== "" &&
        parseFloat(amount) > 0 &&
        (
            billwise === "no" ||
            selectedBillsTotal === parseFloat(amount) ||
            !hasValidBillAmounts
        );

    // const handleAddToCart = () => {
    //     // if (!selectedParty || !amount || !type) return;


    //     const ledgerText = [selectedParty.clientname, `Voucher No: ${voucherNo || ''}`, `Ref No: ${refNo || ''}`].join('\n');
    //     const newEntry = { id: idCounter, ledger: ledgerText, amount, type, partyName: selectedParty.clientname, partyId: selectedParty.id , billwise};

    //     setRows(prev => {
    //         const updated = [...prev];
    //         if (editingRowIndex !== null) {
    //             updated.splice(editingRowIndex, 0, newEntry); // insert at original index
    //         } else {
    //             updated.push(newEntry); // normal add
    //         }
    //         return updated;
    //     });

    //     // Only increment ID if not editing
    //     if (editingRowIndex === null) {
    //         setIdCounter(prev => prev + 1);
    //     }

    //     // Reset fields
    //     setCompanyName('');
    //     setAmount('');
    //     setSelectedParty(null);
    //     setRefNo('');
    //     setEditingRowIndex(null);
    // };

    const handleAddToCart = () => {

        const hasValidBillAmounts =
            selectedBills.some(
                bill => parseFloat(bill.enteredAmount || 0) > 0
            );

        if (
            billwise === "yes" &&
            !hasValidBillAmounts
        ) {
            setConfirmWithoutBillsOpen(true);
            return;
        }

        proceedAddToCart();
    };

    const proceedAddToCart = (overrideBillwise = billwise) => {
        if (!selectedParty || !amount || !type) return;

        const newEntry = {
            id: editingRow ? editingRow.id : idCounter,
            voucherNo,
            ledger: selectedParty.clientname,
            amount,
            type,
            partyName: selectedParty.clientname,
            partyId: selectedParty.id,
            billwise: overrideBillwise,
            selectedBills
        };

        setRows(prev => {
            if (editingRow) {
                return prev.map(row =>
                    row.id === editingRow.id ? newEntry : row
                );
            }
            return [newEntry, ...prev];
        });

        if (!editingRow) {
            setIdCounter(prev => prev + 1);
        }

        // ✅ ALWAYS CLEAR AFTER ADD/UPDATE
        setCompanyName('');
        setAmount('');
        setSelectedParty(null);
        setEditingRow(null);
        setEditingRowIndex(null);
        setBillwise("no");
        setSelectedBills([]);
    };


    const handleContinueWithoutBills = () => {

        setBillwise("no");
        setSelectedBills([]);
        setSelectedIds([]);

        setConfirmWithoutBillsOpen(false);

        // ✅ force no immediately
        proceedAddToCart("no");
    };

    const onSelectResult = (party) => {
        setCompanyName(party.clientname);
        setSelectedParty({
            clientname: party.clientname,
            id: party.id
        });
        setDropdownOpen(false);
    };




    //clear selected bills clear selectedIds when type changes
    const isUserChangingType = useRef(false);

    useEffect(() => {
        if (!type) return;

        // ❌ skip if coming from edit load
        if (!isUserChangingType.current) return;

        // ✅ clear only on user change
        setSelectedBills([]);
        setSelectedIds([]);

        // reset flag
        isUserChangingType.current = false;

    }, [type]);




    // ─── fetch search results ─────────────────────────────────────────────
    useEffect(() => {
        // if (!dropdownOpen) return;   // ← only fetch when dropdown is open

        // setLoadingParty(true);
        const id = setTimeout(async () => {
            try {
                const res = await axios.get(`${API}/api/company-search`, {
                    params: { field: 'FirmName', companyId, search: companyName.trim() || '' }
                });
                const mappedResults = (res.data.data || []).map(item => ({
                    clientname: item.FirmName?.trim() || '',
                    gstno: item.GSTNo || '',
                    contactPerson: item.ContactPerson?.trim() || '',
                    mobileNo: item.MobileNo || '',
                    city: item.City || '',
                    id: item.id
                }));
                setSearchResults(mappedResults);
                setHighlightedIndex(0);
            } catch {
                setSearchResults([]);
            } finally {
                // setLoadingParty(false);
            }
        }, 500);
        return () => clearTimeout(id);
    }, [companyName, dropdownOpen]);  // ← dropdownOpen triggers fetch on focus

    console.log("Rows", rows)


    const BillWisePaidAmt = selectedBills.reduce((sum, b) => {
        const amt =
            b.enteredAmount === "" || b.enteredAmount == null
                ? 0
                : Number(b.enteredAmount);

        return sum + amt;
    }, 0);

    function buildReceivablePayload() {
        // ─── 1) Master fields ─────────────────────────────────────────────
        const L_NO = 0;                            // sequence no.
        const PartyId = selectedParty?.id || null;
        const BankId = null;
        const BookName = "JV";
        // const EntryModule = "JV";
        const ReceiptNumber = voucherNo;
        const ReceiptDate = selectedDate?.format("YYYY-MM-DD");              // JS Date
        const RefNo = refNo;
        const Amount = creditTotal;
        const Debit = debitTotal;
        const Credit = creditTotal;
        const BankComm = 0;
        const TDSAmt = 0;
        const RoundOffAmt = 0;
        const PaidAmt = Amount;
        const VoucherNo = voucherNo;
        const VoucherTotal = Amount;
        const Remark = remark;
        const ClearingAmount = 0;
        const ClearingDate = null;
        const CurrencyId = 0;
        const ExchangeRate = 0;
        const MultiCurrency = false;
        const FYear = getCurrentFYear();
        const CompanyId = companyId;
        const BranchId = null;
        const AddUserId = userId;
        const BillWise = rows.some(r => r.billwise === "yes") ? 1 : 0;

        // ─── 2) JV DETAILS for jvdts ─────────────────────────────────────────
        // one record per DataGrid row
        const jvDetails = rows.map((r, idx) => {
            const amount = parseFloat(r.amount || 0);

            return {
                ReceiptDate: selectedDate?.format("YYYY-MM-DD"),
                BookName,
                PartyId: r.partyId,
                TrType: r.type,
                Debit: r.type === "Dr" ? amount : null,
                Credit: r.type === "Cr" ? amount : null,
                ReceiptNumber,
                CompanyId,
                Billwise: r.billwise === "yes" ? 1 : 0
            };
        });
        // ─── 3) BILL-WISE ENTRIES only if billwise is checked ──────────────
        // const billWiseEntries = BillWise === 1
        //     ? rows.map((r, index) => ({
        //         SrNo: index + 1,
        //         BillAmt: parseFloat(r.amount),
        //         OSAMT: 0,
        //         ChequeAmt: parseFloat(r.amount),
        //         TDSAmt: 0,
        //         RoundOffAmt: 0,
        //         PaidAmt: parseFloat(r.amount),
        //         InvoiceId: null,
        //         Inv_BillNumber: "",
        //         Inv_BillDate: null,
        //         Inv_BillAmt: parseFloat(r.amount),
        //     }))
        //     : [];


        let srCounter = 1;

        const billWiseEntries =
            BillWise === 1
                ? rows.flatMap((r) =>
                    (r.selectedBills || []).map((bill) => {
                        const amt = Number(bill.enteredAmount || 0);

                        return {
                            SrNo: srCounter++,

                            PartyId: Number(r.partyId),
                            TrType: r.type,

                            PurcInvoiceId: bill.PurcInvoiceId ?? (bill.BookName === "PURC" || bill.BookName === "CRNT" ? bill.invoiceId : null),
                            SaleInvoiceId: bill.SaleInvoiceId ?? (bill.BookName === "SALE" || bill.BookName === "DBNT" ? bill.invoiceId : null),

                            BookName: bill.BookName,
                            EntryModule: "JV",

                            BillAmt: Number(bill.BillAmt || 0),

                            //  FIXED: DO NOT SUBTRACT
                            OSAMT: Number(bill.originalOSAmt || bill.OSAmt),

                            ChequeAmt: amt,
                            TDSAmt: 0,
                            RoundOffAmt: 0,
                            PaidAmt: amt,

                            InvoiceId: bill.invoiceId,
                            Inv_BillNumber: bill.BillNumber,
                            Inv_BillDate: bill.BillDate,
                            Inv_BillAmt: Number(bill.BillAmt || 0)
                        };
                    })
                )
                : [];
        // ─── 4) Final payload ────────────────────────────────────────────────
        return {
            ...(isEditMode && { receiptId: id }),

            L_NO, PartyId, BankId, BookName, ReceiptNumber, ReceiptDate,
            RefNo, Amount, BankComm, TDSAmt, RoundOffAmt, PaidAmt,
            VoucherNo, VoucherTotal, Remark, ClearingAmount, ClearingDate,
            CurrencyId, ExchangeRate, MultiCurrency, FYear,
            CompanyId, BranchId, AddUserId, BillWise,
            BillWisePaidAmt, Debit, Credit,

            jvDetails,
            billWiseEntries,
        };
    }

    const handleClear = async () => {
        // set today's date
        setSelectedDate(dayjs());

        // generate new receipt no
        await fetchReceiptNo('JV');

        // reset fields
        setRefNo("");
        setCompanyName('');
        setAmount('');
        setSelectedParty(null);
        setRemark('');
        setRows([]);
        setEditingRow(null);
        setBillwise("no");
        setSelectedBills([]);
    };

    const handleRemoveAllBills = () => {
        setSelectedBills([]);
        setSelectedIds([]);
        setRemoveBillsWarningOpen(false);
    };

    const handleSubmit = async () => {
        try {

            if (billwise === "yes") {
                const hasEmpty = selectedBills.some(
                    b => b.enteredAmount === "" || b.enteredAmount == null
                );

                if (hasEmpty) {
                    setSnackbar({
                        open: true,
                        message: "Please enter amount for all selected bills",
                        severity: "warning"
                    });
                    return;
                }
            }

            const payload = buildReceivablePayload();
            console.log("→ Sending payload:", payload);

            let res;

            if (isEditMode) {
                res = await axios.put(`${API}/api/update-voucher`, payload);

                if (res.data.success) {
                    setSnackbar({
                        open: true,
                        message: "Updated successfully",
                        severity: "success"
                    });

                    setTimeout(() => {
                        navigate(-1);
                    }, 600);
                }

            } else {
                res = await axios.post(`${API}/api/Vouchers`, payload);
                if (res.data.success) {
                    handleClear(); //  ONLY HERE

                    setSnackbar({
                        open: true,
                        message: "Saved successfully",
                        severity: "success"
                    });

                    setTimeout(() => {
                        navigate(-1);
                    }, 600);
                }
            }

        } catch (err) {
            console.error(err);
            setSnackbar({
                open: true,
                message: "Error saving voucher",
                severity: "error"
            });
        }
    };

    const inputSx = { '& .MuiInputBase-root': { height: 40 } };

    const columns = [
        {
            field: 'srNo',
            headerName: '#',
            width: 60,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const total = params.api.getRowsCount();
                const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
                return total - index; // ✅ descending
            }
        },
        {
            field: 'ledger',
            headerName: 'Ledger',
            flex: 3.1,
            renderCell: (params) => {
                const lines = (params.value || "").split('\n');
                return (
                    <Box display="flex" flexDirection="column">
                        <Typography
                            variant="subtitle1"
                            fontWeight={400}
                            sx={{ cursor: 'pointer', color: 'primary.main' }}
                            onClick={() => {
                                const {
                                    partyName,
                                    amount,
                                    type,
                                    id,
                                    voucherNo,
                                    partyId,
                                    billwise: rowBillwise,
                                    selectedBills: rowSelectedBills
                                } = params.row;

                                setCompanyName(partyName);
                                setAmount(amount);
                                setType(type);
                                setSelectedParty({ clientname: partyName, id: partyId });
                                // setVoucherNo(voucherNo);

                                // ✅ FIXED (use row values, not state)
                                setBillwise(rowBillwise || "no");
                                setSelectedBills(rowSelectedBills || []);
                                setSelectedIds((rowSelectedBills || []).map(b => b.id));
                                setEditingRow(params.row);
                            }}
                        >
                            {lines[0] || ''}
                        </Typography>

                        {lines.slice(1).map((line, idx) => (
                            <Typography key={idx} variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                                {line}
                            </Typography>
                        ))}
                    </Box>
                );
            }
        },
        {
            field: 'billwise',
            headerName: 'BillWise',
            flex: 0.6,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                if (!params.value) return '';

                return params.value
                    .toLowerCase()
                    .replace(/\b\w/g, char => char.toUpperCase());
            },
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1.4,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'type',
            headerName: 'Type',
            flex: 0.5,
            headerAlign: 'center',
            align: 'center',
        },
    ];

    const creditTotal = rows.filter(r => r.type === 'Cr').reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
    const debitTotal = rows.filter(r => r.type === 'Dr').reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
    const canSubmit = creditTotal === debitTotal && creditTotal > 0;

    return (
        <>
            <Box mx="auto" px={2} py={1} pb={0} >
                <Typography variant="h5" fontWeight={600} gutterBottom sx={{ textAlign: 'center' }}> Journal Voucher </Typography> </Box>
            <Box sx={{
                px: 2,
                boxSizing: 'border-box',
                width: '100%',        // ← NOT 100vw
                // overflow: 'hidden'
            }}>
                <Grid
                    container
                    spacing={1.5}
                    sx={{
                        height: '82vh',
                    }}
                >

                    {/* Left Form */}
                    <Grid size={{ xs: 12, lg: 5.5 }} sx={{
                        // height: '100%',
                        display: 'flex'  //required
                    }}>
                        <Paper
                            sx={{
                                p: 2,
                                flex: 1,          // instead of height:100%
                                overflowY: 'auto'
                            }}
                        >
                            {/* Top Header Inputs */}
                            <Box sx={{ width: '100%', mb: 2 }}>
                                <Grid container spacing={1.5} alignItems="center">
                                    {/* Date Picker with inline zIndex adjustment */}
                                    <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                        {/* <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="dd/MM/yyyy" popperPlacement="bottom-start"
                                            customInput={<TextField label="Date" size="small" fullWidth sx={inputSx} InputLabelProps={{ shrink: true }} />}
                                        /> */}


                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                            <DatePicker
                                                label="Date"
                                                format="DD/MM/YYYY"
                                                value={selectedDate}
                                                onChange={(val) => setSelectedDate(val)}
                                                minDate={dayjs(fyStartDate)}
                                                maxDate={dayjs(fyEndDate)}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        sx: inputSx,
                                                        InputLabelProps: { shrink: true }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>



                                    </Grid>

                                    {/* Voucher No */}
                                    <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                        <TextField label="Voucher No" size="small" fullWidth disabled sx={inputSx} value={voucherNo} />
                                    </Grid>

                                    {/* Ref No */}
                                    <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                                        <TextField label="Ref No" size="small" fullWidth sx={inputSx} value={refNo} onChange={e => setRefNo(e.target.value)} />
                                    </Grid>
                                </Grid>
                            </Box>

                            {/* Party Dropdown Search */}
                            <Grid item size={{ xs: 12 }} sx={{ mb: 2 }} >
                                <Box sx={{ position: 'relative', overflow: 'visible' }}>
                                    <TextField label={<>Party Name <span style={{ color: "red" }}>*</span></>} size="small" fullWidth sx={inputSx} value={companyName} autoFocus={!isEditMode} onFocus={() => setDropdownOpen(true)}
                                        onBlur={(e) => {
                                            // Delay to allow item selection
                                            setTimeout(() => setDropdownOpen(false), 100);
                                        }}
                                        onChange={(e) => {
                                            setCompanyName(e.target.value);
                                            setDropdownOpen(true);
                                        }}
                                        onKeyDown={(e) => {
                                            if (!dropdownOpen || searchResults.length === 0) return;
                                            if (e.key === 'ArrowDown') {
                                                e.preventDefault();
                                                setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                            } else if (e.key === 'ArrowUp') {
                                                e.preventDefault();
                                                setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                            } else if (e.key === 'Enter') {
                                                e.preventDefault();
                                                const selected = searchResults[highlightedIndex];
                                                if (selected) {
                                                    onSelectResult(selected);
                                                }
                                            } else if (e.key === 'Escape') {
                                                setDropdownOpen(false);
                                            }
                                        }}
                                        inputRef={partyInputRef}
                                    />

                                    {dropdownOpen && anchorRect && (
                                        <Box sx={{
                                            position: 'fixed',
                                            left: anchorRect.left,
                                            top: anchorRect.bottom,
                                            width: '100%',
                                            zIndex: 1300, mt: 1, width: isMdDown ? '500px' : "800px", maxHeight: 300, overflowY: 'auto', boxShadow: 4,
                                        }} >
                                            {isMdDown ? (
                                                // ─── Cards on small/medium ───
                                                searchResults.map((r, i) => (
                                                    <Card key={i} variant="outlined" sx={{ mb: 1, cursor: 'pointer', backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent' }} onMouseEnter={() => setHighlightedIndex(i)} onMouseDown={() => onSelectResult(r)} >
                                                        <CardContent >
                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                {r.clientname}
                                                            </Typography>
                                                            <Typography variant="body2">GST: {r.gstno}</Typography>
                                                            <Typography variant="body2">Contact: {r.contactPerson}</Typography>
                                                            <Typography variant="body2">Mobile: {r.mobileNo}</Typography>
                                                            <Typography variant="body2">City: {r.city}</Typography>
                                                        </CardContent>
                                                    </Card>
                                                ))
                                            ) : (
                                                // ─── Table on desktop ───
                                                <TableContainer component={Paper}>
                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Company</TableCell>
                                                                <TableCell>GST No</TableCell>
                                                                <TableCell>Contact</TableCell>
                                                                <TableCell>Mobile</TableCell>
                                                                <TableCell>City</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {searchResults.length > 0 ? (
                                                                searchResults.map((r, i) => (
                                                                    <TableRow key={i} hover selected={i === highlightedIndex} sx={{ cursor: 'pointer' }} onMouseEnter={() => setHighlightedIndex(i)} onMouseDown={() => onSelectResult(r)} >
                                                                        <TableCell>{r.clientname}</TableCell>
                                                                        <TableCell>{r.gstno}</TableCell>
                                                                        <TableCell>{r.contactPerson}</TableCell>
                                                                        <TableCell>{r.mobileNo}</TableCell>
                                                                        <TableCell>{r.city}</TableCell>
                                                                    </TableRow>
                                                                ))
                                                            ) : (
                                                                <TableRow>
                                                                    <TableCell colSpan={5} align="center"> No Data Available </TableCell>
                                                                </TableRow>
                                                            )}
                                                            <TableRow hover sx={{ cursor: 'pointer' }} onMouseDown={() => setShowClientModal(true)} >
                                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main' }}>
                                                                    ➕ Add New Client
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                            <Grid container spacing={1.5}>

                                <Grid item size={{ xs: 4 }}>

                                    <Grid container spacing={2} direction="column">
                                        <Grid item >
                                            <TextField select label={<>Type <span style={{ color: "red" }}>*</span></>} size="small" fullWidth value={type} onChange={(e) => {
                                                isUserChangingType.current = true;   // mark user action
                                                setType(e.target.value);
                                            }}>
                                                <MenuItem value="Cr">Cr</MenuItem>
                                                <MenuItem value="Dr">Dr</MenuItem>
                                            </TextField>
                                        </Grid>

                                        <Grid item >
                                            <TextField label={<>Amount <span style={{ color: "red" }}>*</span></>} size="small" fullWidth value={amount}
                                                onChange={e => {
                                                    if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                                                        setAmount(e.target.value);
                                                    }
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                {/* Remark */}
                                <Grid item size={{ xs: 8 }}>
                                    <TextField label="Remark" value={remark} onChange={e => setRemark(e.target.value)} fullWidth multiline size="small" sx={{ mb: 2 }} rows={3.5} />
                                </Grid>
                            </Grid>

                            {/* Billwise Box */}
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%"
                                }}
                            >
                                {/* LEFT: Billwise */}
                                <Box display="flex" alignItems="center" pl={2} mt={-1}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={billwise === 'yes'}
                                                onChange={(e) =>
                                                    setBillwise(e.target.checked ? 'yes' : 'no')
                                                }
                                                color="primary"
                                            />
                                        }
                                        label="Billwise?"
                                    />
                                </Box>

                                {/* RIGHT: Buttons */}
                                {billwise === "yes" && (
                                    <Box display="flex" gap={1} pr={2}>

                                        <Button
                                            variant="outlined"
                                            // color="secondary"
                                            onClick={handleAutoSelect}
                                            disabled={!selectedParty || !type || Number(amount) <= 0}
                                        >
                                            Auto Select Bills
                                        </Button>

                                        {/* <Button
                                            variant="contained"
                                            onClick={() => {
                                                fetchInvoices();
                                                setSelectedIds(selectedBills.map(b => b.id));
                                                setModalOpen(true);
                                            }}
                                            disabled={!selectedParty || !type || Number(amount) <= 0}
                                        >
                                            Show Bills
                                        </Button> */}


                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                // ✅ snapshot current state before modal opens
                                                setBillsSnapshot(selectedBills);
                                                setIdsSnapshot(selectedIds);

                                                fetchInvoices();
                                                setSelectedIds(selectedBills.map(b => b.id));
                                                setModalOpen(true);
                                            }}
                                            disabled={!selectedParty || !type || Number(amount) <= 0}
                                        >
                                            Show Bills
                                        </Button>

                                    </Box>
                                )}
                            </Box>


                            {/* Add Button */}
                            <Box display="flex" justifyContent="center" mt={2}>
                                <Button variant="contained" sx={{ width: 200 }} onClick={handleAddToCart} disabled={!isValidForAddToCart}>
                                    {editingRow ? 'Update Cart' : 'Add to Cart'}
                                </Button>
                            </Box>

                            {billwise === "yes" && selectedBills.length > 0 && (
                                <Box mt={3}>
                                    <Typography fontWeight="bold">Selected Bills</Typography>

                                    {editingRow && (
                                        <Box display="flex" justifyContent="flex-end" mb={1}>
                                            <Button variant="outlined" color="error" onClick={() => setRemoveBillsWarningOpen(true)}>
                                                Remove All Bills
                                            </Button>
                                        </Box>
                                    )}

                                    {isMobile ? (
                                        <Box sx={{ mt: 1 }}>
                                            {selectedBills.map((row) => (
                                                <SelectedBillCard
                                                    key={row.id}
                                                    row={row}
                                                    selectedIds={selectedIds}
                                                    setSelectedIds={setSelectedIds}
                                                    setSelectedBills={setSelectedBills}
                                                    invoiceUsageMap={invoiceUsageMap}
                                                    setSnackbar={setSnackbar}
                                                />
                                            ))}
                                        </Box>
                                    ) : (
                                        <DataGrid
                                            rows={selectedBills}
                                            columns={[
                                                { field: "BillNumber", headerName: "Invoice No", flex: 1 },
                                                { field: "BookName", headerName: "Book Name", flex: 0.8 },
                                                {
                                                    field: "BillDate", headerName: "Bill Dt", flex: 1,
                                                    valueFormatter: (value) => {
                                                        if (!value) return "";

                                                        const date = new Date(value);

                                                        if (isNaN(date)) return value;

                                                        return date.toLocaleDateString("en-GB");
                                                    }
                                                },
                                                { field: "OSAmt", headerName: "O/S Amount", flex: 1 },
                                                {
                                                    field: "enteredAmount",
                                                    headerName: "Amount",
                                                    flex: 1.2,
                                                    renderCell: (params) => (
                                                        <TextField
                                                            size="small"
                                                            value={params.row.enteredAmount}
                                                            inputProps={{
                                                                inputMode: "decimal",
                                                                pattern: "^[0-9]*\\.?[0-9]*$",
                                                                min: 0
                                                            }}
                                                            onChange={(e) => {
                                                                const raw = e.target.value;

                                                                // ❌ block invalid input (only numbers + decimal, no negative)
                                                                if (!/^\d*\.?\d{0,2}$/.test(raw)) return;

                                                                const val = Number(raw || 0);
                                                                const id = params.row.id;

                                                                const usedFromRows = invoiceUsageMap[id]?.usedAmount || 0;

                                                                const usedFromCurrent = selectedBills
                                                                    .filter(b => b.id === id)
                                                                    .reduce((sum, b) => {
                                                                        if (b.id === params.row.id) return sum; // skip current row
                                                                        return sum + Number(b.enteredAmount || 0);
                                                                    }, 0);

                                                                const totalUsed = usedFromRows + usedFromCurrent;

                                                                const max = Number(params.row.OSAmt) - totalUsed;

                                                                // ❌ prevent over allocation
                                                                if (val > max) {
                                                                    setSnackbar({
                                                                        open: true,
                                                                        message: `Max allowed: ${max}`,
                                                                        severity: "warning"
                                                                    });
                                                                    return;
                                                                }

                                                                // ❌ prevent negative (extra safety)
                                                                if (val < 0) return;

                                                                setSelectedBills(prev => {
                                                                    const updated = prev.map(row =>
                                                                        row.id === params.row.id
                                                                            ? { ...row, enteredAmount: raw }
                                                                            : row
                                                                    );

                                                                    // ✅ KEEP SELECTION STABLE
                                                                    setSelectedIds(updated.map(r => r.id));

                                                                    return updated;
                                                                });
                                                            }}
                                                        />
                                                    )
                                                }
                                            ]}
                                            getRowId={(row) => row.id}
                                            hideFooter
                                            sx={{ mt: 1 }}

                                            checkboxSelection
                                            disableRowSelectionOnClick
                                            rowSelectionModel={selectedIds}
                                            onRowSelectionModelChange={(newSelection) => {
                                                const removedIds = selectedIds.filter(id => !newSelection.includes(id));

                                                // ✅ remove unchecked rows
                                                setSelectedBills(prev =>
                                                    prev.filter(row => !removedIds.includes(row.id))
                                                );

                                                // ✅ update selection
                                                setSelectedIds(newSelection);
                                            }}
                                        />
                                    )}
                                </Box>
                            )}
                        </Paper>
                    </Grid>

                    {/* Right Grid - Data Table */}
                    <Grid

                        size={{ xs: 12, lg: 6.5 }}
                        sx={{
                            height: '100%',
                            display: 'flex', //REQUIRED
                            minWidth: 0,
                        }}
                    >
                        <Paper
                            sx={{
                                flex: 1,                  //  THIS replaces height:100%
                                display: 'flex',
                                flexDirection: 'column',
                                minHeight: 0,          //  CRITICAL for DataGrid
                                minWidth: 0,     // ← add this
                                overflow: 'hidden'  // ← add this
                            }}
                        >
                            {/* Scrollable DataGrid */}
                            <Box
                                sx={{
                                    flex: 1,
                                    minHeight: 0,             //  CRITICAL
                                    overflow: 'hidden'
                                }}
                            >



                                {isMobile ? (
                                    <Box sx={{ flex: 1, overflowY: "auto", p: 1 }}>
                                        {rows.length === 0 ? (
                                            <NoDataComponent />
                                        ) : (
                                            rows.map((row, index) => (
                                                <CartRowCard
                                                    key={row.id}
                                                    row={row}
                                                    index={index}
                                                    total={rows.length}
                                                    onEdit={() => {
                                                        setCompanyName(row.partyName);
                                                        setAmount(row.amount);
                                                        setType(row.type);
                                                        setSelectedParty({ clientname: row.partyName, id: row.partyId });
                                                        setBillwise(row.billwise || "no");
                                                        setSelectedBills(row.selectedBills || []);
                                                        setSelectedIds((row.selectedBills || []).map(b => b.id));
                                                        setEditingRow(row);
                                                    }}
                                                />
                                            ))
                                        )}
                                    </Box>
                                ) : (
                                    <DataGrid
                                        apiRef={apiRef}
                                        rows={rows}
                                        columns={columns}
                                        // ✅ remove hideFooter
                                        initialState={{
                                            pagination: { paginationModel: { pageSize: 10 } },
                                        }}
                                        pageSizeOptions={[10, 20, 30]}
                                        getRowHeight={() => 'auto'}
                                        disableRowSelectionOnClick
                                        slots={{
                                            noRowsOverlay: () => (
                                                <NoDataComponent />
                                            ),
                                        }}
                                        sx={{
                                            height: "100%",
                                            border: '1px solid #cbd5e1',
                                            borderRadius: 1,
                                            '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
                                            '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                                            // Background styling
                                            '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                            '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                                            // Row styling
                                            '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                            '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                            '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                                            // Selected row styling (with !important to override default MUI)
                                            '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },
                                            "& .MuiDataGrid-footerContainer": {
                                                minHeight: "35px",
                                                maxHeight: "35px",
                                            },
                                        }}
                                    />
                                )}



                                {/* <CommonServerDataGrid
    data={rows.slice().reverse()}
    columns={columns}
    getRowId={(row) => row.id}
    role={userCategory}          // or any role logic you use
    // selectionModel={selectionModel}
    // onSelectionModelChange={setSelectionModel}
    hideFooter                   // if your reusable grid supports it
    getRowHeight={() => "auto"}  // forwarded to MUI DataGrid
/> */}

                            </Box>

                            {/* Footer */}
                            <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
                                <Box>
                                    <Typography variant="subtitle1">Total Credit: ₹{creditTotal.toFixed(2)}</Typography>
                                    <Typography variant="subtitle1">Total Debit: ₹{debitTotal.toFixed(2)}</Typography>
                                </Box>
                                <Button variant="contained" color="success" disabled={!canSubmit} onClick={handleSubmit} sx={{ minWidth: 140 }} >
                                    {isEditMode ? "Update" : "Submit"}
                                </Button>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>


                <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                    <Alert
                        severity={snackbar.severity}
                        variant="filled"
                        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>

                <Dialog
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    maxWidth="lg"
                    fullWidth
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 18px 0px 18px"
                        }}
                    >
                        <Typography fontWeight="bold">
                            Pending Invoices
                        </Typography>

                        <Typography sx={{ fontWeight: 500 }}>
                            Amount: {parseFloat(amount || 0).toFixed(2)}
                        </Typography>
                    </Box>


                    <DialogContent
                        sx={{
                            height: "80vh",
                            display: "flex",
                            flexDirection: "column",
                            p: 2
                        }}
                    >

                        {isMobile ? (
                            <Box sx={{ flex: 1, overflowY: "auto" }}>
                                {loadingInvoices ? (
                                    <Typography sx={{ textAlign: "center", py: 3 }}>Loading...</Typography>
                                ) : invoiceData.length === 0 ? (
                                    <NoDataComponent />
                                ) : (
                                    invoiceData.map((row) => (
                                        <PendingInvoiceCard
                                            key={row.id}
                                            row={row}
                                            selectedIds={selectedIds}
                                            setSelectedIds={setSelectedIds}
                                            selectedBills={selectedBills}
                                            setSelectedBills={setSelectedBills}
                                            invoiceUsageMap={invoiceUsageMap}
                                            currentEditingInvoiceIds={currentEditingInvoiceIds}
                                        />
                                    ))
                                )}
                            </Box>
                        ) : (
                            <DataGrid
                                rows={invoiceData}
                                columns={[
                                    {
                                        field: "BillNumber",
                                        headerName: "Bill No",
                                        flex: 1,
                                        renderCell: (params) => {
                                            const isUsed = !!invoiceUsageMap[params.row.id];

                                            const content = (
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <span>{params.value}</span>

                                                    {isUsed && (
                                                        <Chip
                                                            label="Used"
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: "#d32f2f",
                                                                color: "#fff",
                                                                fontWeight: 500,
                                                                height: 20,
                                                                fontSize: "11px",
                                                                "& .MuiChip-label": {
                                                                    px: 1
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            );

                                            // ✅ Only wrap tooltip if used
                                            return isUsed ? (
                                                <Tooltip title="This invoice is already used" arrow placement="right">
                                                    <Box sx={{ width: "100%" }}>{content}</Box>
                                                </Tooltip>
                                            ) : (
                                                content
                                            );
                                        }
                                    },
                                    { field: "BookName", headerName: "Book Name ", flex: 1 },
                                    {
                                        field: "BillDate", headerName: "Bill Date", flex: 1,
                                        valueFormatter: (value) => {
                                            if (!value) return "";

                                            const date = new Date(value);

                                            if (isNaN(date)) return value;

                                            return date.toLocaleDateString("en-GB");
                                        }
                                    },
                                    { field: "OSAmt", headerName: "O/S Amount", flex: 1 },
                                    // {
                                    //     field: "UsedIn",
                                    //     headerName: "Used In",
                                    //     flex: 1,
                                    //     renderCell: (params) => {
                                    //         const id = params.row.id;

                                    //         const rowsUsed = invoiceUsageMap[id]?.rows || [];

                                    //         return rowsUsed.length > 0
                                    //             ? `row-${rowsUsed.join(", ")}`
                                    //             : "-";
                                    //     }
                                    // },
                                    {
                                        field: "DueDate", headerName: "Due Date", flex: 1,
                                        valueFormatter: (value) => {
                                            if (!value) return "";

                                            const date = new Date(value);

                                            if (isNaN(date)) return value;

                                            return date.toLocaleDateString("en-GB");
                                        }
                                    },

                                ]}

                                slots={{
                                    noRowsOverlay: () => (
                                        <NoDataComponent />
                                    ),
                                }}

                                checkboxSelection
                                disableRowSelectionOnClick
                                rowSelectionModel={selectedIds}
                                onRowSelectionModelChange={(ids) => {
                                    setSelectedIds(ids);

                                    const selectedRows = invoiceData.filter(row =>
                                        ids.includes(row.id)
                                    );

                                    const formatted = selectedRows.map(row => {
                                        const used = invoiceUsageMap[row.id]?.usedAmount || 0;
                                        const remaining = Number(row.OSAmt) - used;

                                        // preserve existing enteredAmount if exists
                                        const existing = selectedBills.find(b => b.id === row.id);

                                        return {
                                            ...row,
                                            enteredAmount: existing?.enteredAmount ?? ""
                                        };
                                    });

                                    setSelectedBills(formatted);
                                }}
                                isRowSelectable={(params) => {
                                    const id = params.row.id;

                                    const isUsed = !!invoiceUsageMap[id]; // ✅ simple check
                                    const isCurrent = currentEditingInvoiceIds.includes(id);

                                    if (isCurrent) return true;

                                    return !isUsed; // ❌ block if already used
                                }}
                                getRowClassName={(params) => {
                                    const id = params.row.id;

                                    const isUsed = !!invoiceUsageMap[id];
                                    const isCurrent = currentEditingInvoiceIds.includes(id);

                                    if (isCurrent) return "current-row";
                                    if (isUsed) return "fully-used";

                                    return "";
                                }}

                                sx={{
                                    height: "100%",

                                    "& .fully-used": {
                                        backgroundColor: "#ffecec",
                                        color: "#d32f2f",

                                    },

                                    "& .current-row": {
                                        backgroundColor: "#e3f2fd"
                                    }
                                }}
                            />
                        )}


                        <Box
                            sx={{
                                mt: 1,
                                pt: 1,
                                borderTop: "1px solid #d0d4d9",
                                display: "flex",
                                justifyContent: "space-between"
                            }}
                        >
                            {/* <Typography sx={{ fontWeight: "bold", color: "#1a3c6c" }}>
                                            Selected O/S Total: {selectedPendingTotal.toFixed(2)}
                                        </Typography> */}
                        </Box>


                        <Box sx={{ textAlign: "right", mt: 2 }}>
                            {/* <Button
                                variant="contained"
                                sx={{ mr: 2 }}
                                disabled={selectedIds.length === 0}
                                onClick={() => {
                                    const selectedRows = invoiceData.filter(row =>
                                        selectedIds.includes(row.id)
                                    );

                                    // const alreadySelectedInvoiceIds = rows
                                    //     .filter(r => !(editingRow && r.id === editingRow.id))
                                    //     .flatMap(r =>
                                    //         (r.selectedBills || []).map(b => b.id)   // ✅ composite id
                                    //     );

                                    // ❌ remove duplicates
                                    const filtered = selectedRows.filter(row => {
                                        const id = row.id;
                                        return !invoiceUsageMap[id]; // ❌ block if already used
                                    });

                                    const blockedRows = selectedRows.filter(row => {
                                        const id = row.id;
                                        const used = invoiceUsageMap[id]?.usedAmount || 0;
                                        const remaining = row.OSAmt - used;

                                        return remaining === 0;
                                    });

                                    if (filtered.length !== selectedRows.length) {
                                        setSnackbar({
                                            open: true,
                                            message: "Some invoices already used",
                                            severity: "warning"
                                        });
                                    }
                                    const formatted = filtered.map(row => {
                                        const used = invoiceUsageMap[row.id]?.usedAmount || 0;
                                        const remaining = Number(row.OSAmt) - used;

                                        return {
                                            ...row,
                                            id: row.id, // ✅ already composite
                                            enteredAmount: row.OSAmt
                                        };
                                    });

                                    setSelectedBills(formatted);

                                    // ✅ sync selection
                                    setSelectedIds(formatted.map(b => b.id));
                                    setModalOpen(false);
                                }}
                            >
                                Save
                            </Button> */}

                            <Button
                                variant="contained"
                                sx={{ mr: 2 }}
                                disabled={selectedIds.length === 0}
                                onClick={() => {
                                    const selectedRows = invoiceData.filter(row =>
                                        selectedIds.includes(row.id)
                                    );

                                    const formatted = selectedRows.map(row => {
                                        const used = invoiceUsageMap[row.id]?.usedAmount || 0;
                                        const remaining = Number(row.OSAmt) - used;
                                        const existing = billsSnapshot.find(b => b.id === row.id); // ✅ use snapshot

                                        return {
                                            ...row,
                                            id: row.id,
                                            enteredAmount: existing?.enteredAmount ?? ""
                                        };
                                    });

                                    setSelectedBills(formatted);
                                    setSelectedIds(formatted.map(b => b.id));

                                    // ✅ clear snapshot
                                    setBillsSnapshot([]);
                                    setIdsSnapshot([]);

                                    setModalOpen(false);
                                }}
                            >
                                Save
                            </Button>

                            {/* <Button
                                onClick={() => setModalOpen(false)}
                                variant="outlined"
                            >
                                Cancel
                            </Button> */}

                            <Button
                                onClick={() => {
                                    // ✅ restore what was there before modal opened
                                    setSelectedBills(billsSnapshot);
                                    setSelectedIds(idsSnapshot);
                                    setModalOpen(false);
                                }}
                                variant="outlined"
                            >
                                Cancel
                            </Button>
                        </Box>


                    </DialogContent>
                </Dialog>



                <Dialog
                    open={removeBillsWarningOpen}
                    onClose={() => setRemoveBillsWarningOpen(false)}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>
                        Remove Bills
                    </DialogTitle>

                    <DialogContent>
                        <Typography sx={{ mb: 2 }}>
                            Are you sure you want to remove all selected bills?
                        </Typography>

                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap={1}
                        >
                            <Button
                                onClick={() => setRemoveBillsWarningOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleRemoveAllBills}
                            >
                                Remove
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>


                <Dialog
                    open={confirmWithoutBillsOpen}
                    onClose={() => setConfirmWithoutBillsOpen(false)}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>
                        Continue Without Bills
                    </DialogTitle>

                    <DialogContent>
                        <Typography sx={{ mb: 2 }}>
                            Are you sure you want to continue without billwise entries?
                        </Typography>

                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            gap={1}
                        >
                            <Button
                                onClick={() =>
                                    setConfirmWithoutBillsOpen(false)
                                }
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleContinueWithoutBills}
                            >
                                Yes
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog>

            </Box>
        </>
    );
};

export default Vouchers;